import { merge, omit } from 'lodash';
import {
  DesignModule,
  DesignModuleNode,
  DesignObject,
  NodeType
} from '../../../types';
import Seed from '../../../utilities/Seed';
import Utility from '../../../utilities/Utility';
import { DiagnoseFixResult } from './types';

export const fixMissingObjects = (orphanNodes: DesignModuleNode[]): DiagnoseFixResult => {
  const nodesForUpdate:  DesignModuleNode[] = [];
  const createdDesignItems = new Map<NodeType, Set<string>>();

  try {
    orphanNodes.forEach((node) => {
      let id = node.props?.parentComponentID;
      if (!id) {
        id = Utility.uuid4();
        nodesForUpdate.push(merge(node, { props: { parentComponentID: id } }));
      }
      if (createdDesignItems.get(node._class)?.has(id)) {
        return;
      }

      let seedItem: DesignModule | DesignObject;
      if (node._class === NodeType.module) {
        seedItem = Seed.getBlankModuleObject(node.name, node.props.config.description ?? '');
      } else {
        const { items: seedObjects } = Seed.getElements().objects[0];
        seedItem = (
          seedObjects.find(({ _class }) => _class === node._class)
          ?? seedObjects[0]
        );
      }
      const parent = {
        ...seedItem,
        ...omit(node, ['props', 'type', 'x', 'y']),
        props: {
          ...(omit(node.props, [
            'commonModuleName',
            'commonModuleVersion',
            'hasWizardConfig',
            'isRootModule',
            'lastSavedChange',
            'readOnly',
            'ref',
            'validatorError'
          ]) as DesignObject['props']),
          lastLocalChange: window.apm.timestamp
        },
        id
      } as unknown as DesignModule | DesignObject;
      const classSet = createdDesignItems.get(parent._class) ?? new Set();
      classSet.add(parent.id);
      createdDesignItems.set(parent._class, classSet);
      window.apm.addNode(parent);
    });
    nodesForUpdate.forEach((node) => {
      window.apm.setNode(node.id, node);
    });
    return {
      message: (
        `${orphanNodes.length} parent objects were created`
        + ((nodesForUpdate.length) ? ` and updated ${nodesForUpdate.length} node(s)` : '')
        + '.'
      )
    };
  } catch (error) {
    console.error(error);
    return {
      message: (
        `Error creating ${orphanNodes.length} objects`
        + ((nodesForUpdate.length) ? ` and updating ${nodesForUpdate.length} node(s)` : '')
        + '.'
      ),
      error
    };
  }
};
